import { generateClearResourceAction, generateStoreResourceAction } from '../generators/resource.actions';

import * as constants from './invoice.constants';
import * as types from './invoice.types';

export const storeInvoice = generateStoreResourceAction<types.IInvoice>(constants.STORE_INVOICE);
export const clearInvoice = generateClearResourceAction(constants.CLEAR_INVOICE);
